<template>
  <div class="radar_section">
    <RadarSectionLine
      v-for="line in sectionLines"
      :key="line.id"
      class="radar_section__line"
      :line-color="line.id === 'line_0' ? inactiveColor : actualSectionColor"
      :rotate-angle="line.rotateAngle"
    />

    <!-- active dots -->
    <RadarDot
      v-for="dot in sectionKpiDots"
      :key="dot.id"
      class="radar_section__dot"
      :is-active="dot.id === 'dot_' + activeKpiIndex ? true : false"
      :circle-color="actualSectionColor"
      :style="{ left: dot.left + '%', top: dot.top + '%' }"
    />

    <div v-if="showKPILabels">
      <span
        v-for="label in sectionLabels"
        :key="label.label"
        class="radar_section__kpi_label"
        :style="{
          transform: 'rotate(' + (360 - rotation) + 'deg)',
          left: label.left + 'px',
          top: label.top + 'px',
        }"
        >{{ label.label }}</span
      >
    </div>

    <span
      v-if="!showKPILabels"
      class="radar_section__label"
      :style="{ transform: 'rotate(' + (360 - rotation) + 'deg)', color: actualSectionColor }"
      >{{ labelName }}</span
    >

    <!-- click divs -->
    <div
      v-for="dot in sectionKpiDots"
      :key="'click_' + dot.id"
      class="radar_section__clickarea"
      :style="{ left: dot.left + '%', top: dot.top + '%' }"
      @click="$emit('click-dot', sectionIndex + '_' + dot.id.split('_')[1])"
    />
  </div>
</template>

<script>
import RadarDot from './RadarDot';
import RadarSectionLine from './RadarSectionLine';

export default {
  name: 'RadarSection',

  components: {
    RadarDot,
    RadarSectionLine,
  },

  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
    activeKpiIndex: {
      type: Number,
      required: true,
    },
    sectionColor: {
      type: String,
      required: true,
    },
    inactiveColor: {
      type: String,
      default: 'rgba(255,255,255,255)',
    },
    rotation: {
      type: Number,
      required: true,
    },
    labelName: {
      type: String,
      required: true,
    },
    sectionLabels: {
      type: Array,
      default: null,
    },
    showKPILabels: {
      type: Boolean,
      default: false,
    },
    sectionIndex: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      sectionLines: [
        {
          id: 'line_0',
          rotateAngle: -75,
        },
        {
          id: 'line_1',
          rotateAngle: -35,
        },
        {
          id: 'line_2',
          rotateAngle: 5,
        },
      ],

      sectionKpiDots: [
        {
          id: 'dot_0',
          top: 0,
          left: 62,
        },
        {
          id: 'dot_1',
          top: 21,
          left: 87.5,
        },
        {
          id: 'dot_2',
          top: 53.5,
          left: 94,
        },
      ],
    };
  },

  computed: {
    actualSectionColor() {
      return this.isActive ? this.sectionColor : this.inactiveColor;
    },
  },
};
</script>

<style lang="scss" scoped>
.radar_section {
  position: absolute;
  top: -1px;
  left: 0px;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.radar_section__label {
  position: absolute;
  left: 272px;
  top: 38px;
  text-align: center;
  height: 38px;
  width: 80px;
  line-height: 40px;
}

.radar_section__kpi_label {
  position: absolute;
  left: 0;
  top: 0;
  text-align: center;
  height: 38px;
  width: 80px;
  font-size: 13px;
  line-height: 15px;

  @include helper__greater($bp-1024) {
    height: 28px;
    width: 80px;
    font-size: 8px;
    line-height: 13px;
  }
}

.radar_section__line,
.radar_section__dot {
  position: absolute;
  top: 0;
  left: 0;
}

.radar_section__clickarea {
  position: absolute;
  width: 30px;
  height: 30px;
  cursor: pointer;
  pointer-events: auto;
  z-index: 100;
}
</style>
